import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MuiModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuAnnouncementModule } from '../announcement';
import { MmuBrowserSupportModule } from '../browser-support/mmu-browser-support.module';
import { MmuFeatureFlagsModule } from '../feature-flags';
import { MmuFooterModule } from '../footer/mmu-footer.module';
import { MmuMainMenuModule } from '../main-menu';
import { MmuMaintenanceModule } from '../maintenance';
import { MmuTitleModule } from '../title/mmu-title.module';
import { MmuHeroMenuFrameComponent } from './hero-menu-frame/mmu-hero-menu-frame.component';
import { MmuMoveBgFrameComponent } from './move-bg-frame/mmu-move-bg-frame.component';
import { MmuMoveParallaxBgComponent } from './move-bg-frame/parallax-bg/mmu-move-parallax-bg.component';
import { MmuStripedDiamondBgComponent } from './move-bg-frame/striped-diamond-bg/mmu-striped-diamond-bg.component';
import { MmuReducedFrameGrayComponent } from './reduced-frame/mmu-reduced-frame-gray/mmu-reduced-frame-gray.component';
import { MmuReducedFrameComponent } from './reduced-frame/mmu-reduced-frame-white/mmu-reduced-frame.component';


@NgModule({
  declarations: [
    MmuHeroMenuFrameComponent,
    MmuReducedFrameComponent,
    MmuMoveBgFrameComponent,
    MmuMoveParallaxBgComponent,
    MmuStripedDiamondBgComponent,
    MmuReducedFrameGrayComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MuiModule,
    MmuTitleModule,
    MmuFooterModule,
    MmuBrowserSupportModule,
    MmuMaintenanceModule,
    MmuMainMenuModule,
    MmuAnnouncementModule,
    MmuFeatureFlagsModule
  ],
  exports: [
    MmuReducedFrameComponent,
    MmuHeroMenuFrameComponent,
    MmuMoveBgFrameComponent,
    MmuMoveParallaxBgComponent,
    MmuStripedDiamondBgComponent
  ]
})
export class MmuAppFramesModule {
}
